import { createSlice } from "@reduxjs/toolkit";

const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
const initialStateValue = {
  value: {
    siteName: "",
    siteAddress: {
      value: "",
      coordinates: { lat: "", lng: "", coords: "" },
    },
    dateOfInstallation: getCurrentDate(),
    customerName: "",
    customerEmail: "",
    customerPhoneNo: "",
    pixelValue: 20,
    mapOption: {
      mapTypeId: "roadmap",
      zoom: 6,
    },
    boxDimension: [],
    polygonCoordinates: [],
    abstacles: [],
    nearestWeatherStation: "Select Weather Station",
    financialAnalysis: {
      currency: "PKR",
      tpc: 0,
      aeci: 3,
      aetIncrease: 3,
      exportTriff: 10,
      et: 42,
      tcy: 4484,
      jan: 229,
      feb: 143,
      mar: 192,
      apr: 259,
      may: 477,
      jun: 562,
      jul: 732,
      aug: 589,
      sep: 608,
      oct: 313,
      nov: 171,
      dec: 209,
    },
    inverterAnalysis: {
      systemType: "On Grid",
      inverterPhase: "Three Phase",
      inverterManufacturer: "Select",
      inverterType: "Select",
      powerSensor: "No Power Sensor",
      communicationDevice: "No Communication Device",
      noOfInverter: 0,
      DCACRatio: 1.2,
      feedMeter: false,
      noOfStringMPPT: 0,
      actualStringMPPT: 0,
      actualString: 0,
      totalStringMPPT: 0,
      lastStringMPPT: 0,
      error: "",
      errorShow: false,
      oneLineMethod: "strings/MPPT",
    },
  },
};

export const newRoofSlice = createSlice({
  name: "newRoof",
  initialState: initialStateValue,
  reducers: {
    projectInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateRoofInfo: (state, action) => {
      state.value = { ...state.value, ...action.payload };
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    deletePolygonCoordinates: (state, action) => {
      state.value.polygonCoordinates = action.payload;
      console.log("hehe", state.value.polygonCoordinates);
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    PolygonCoordinates: (state, action) => {
      state.value.polygonCoordinates = [
        ...state.value.polygonCoordinates,
        action.payload,
      ];
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    updatedPolygonCoordinates: (state, action) => {
      const { index, value } = action.payload;
      state.value.polygonCoordinates[index] = value;
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    AbstaclesPoint: (state, action) => {
      state.value.abstacles = [...state.value.abstacles, action.payload];
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    updatedAbstacles: (state, action) => {
      const { index, value } = action.payload;
      state.value.abstacles[index] = value;
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    updatefinancialAnalysis: (state, action) => {
      state.value.financialAnalysis = {
        ...state.value.financialAnalysis,
        ...action.payload,
      };
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    updateInverterAnalysis: (state, action) => {
      state.value.inverterAnalysis = {
        ...state.value.inverterAnalysis,
        ...action.payload,
      };
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    updateTcy: (state, action) => {
      state.value.financialAnalysis.tcy = action.payload;
      sessionStorage.setItem("projects", JSON.stringify(state));
    },
    resetRoofInfo: (state, action) => {
      return initialStateValue;
    },
  },
});

export const {
  projectInfo,
  updatedPolygonCoordinates,
  updateRoofInfo,
  PolygonCoordinates,
  AbstaclesPoint,
  updatedAbstacles,
  updatefinancialAnalysis,
  updateTcy,
  updateInverterAnalysis,
  resetRoofInfo,
  deletePolygonCoordinates,
} = newRoofSlice.actions;

export default newRoofSlice.reducer;
